import { IonLabel } from "@ionic/react";
import { Trans } from "react-i18next";
import { useTheme } from "react-jss";
import { useHistory } from "react-router";
import { AppRoutes } from "../../constants/appRoutes";
import { isCompatibleBrowserPushNotification } from "../../services/pushnotification";
import { getUserAgent, isAndroidBrowser, isIPhoneBrowser, isRunningFromHomeScreen } from "../../services/userAgent";
import { AboutBrowserControllerStyle } from "./controllerStyle.jss";

export const AboutBrowserController = () => {
    const versionIOSRequired = 16.4;
    const theme = useTheme();
    const style = AboutBrowserControllerStyle({ theme });
    const history = useHistory();
    const userAgent = getUserAgent();

    if (isIPhoneBrowser()) {
        const isRunningHome = isRunningFromHomeScreen();
        const isVersionCompatible = userAgent.version >= versionIOSRequired;

        if (!isVersionCompatible) {
            return (
                <IonLabel
                    className={style.text}
                    color="warning"
                >
                    <Trans i18nKey="MESSAGES.BROWSER_SAFARI_NOT_COMPATIBLE" />
                </IonLabel>
            );
        }

        if (!isRunningHome) {
            const message = isVersionCompatible ? "MESSAGES.BROWSER_SAFARI_COMPATIBLE" : "MESSAGES.BROWSER_SAFARI_NOT_COMPATIBLE";

            const onClickAction = isVersionCompatible ? () => history.push(AppRoutes.ABOUT_IOS) : undefined;

            return (
                <IonLabel
                    className={style.text}
                    onClick={onClickAction}
                    color={isVersionCompatible ? "secondary" : "warning"}
                >
                    <Trans i18nKey={message} />
                </IonLabel>
            );
        }
    }

    if (isAndroidBrowser() && !isCompatibleBrowserPushNotification()) {
        return (
            <IonLabel
                color="warning"
                className={style.text}
            >
                <Trans i18nKey="MESSAGES.BROWSER_NOT_COMPATIBLE" />
            </IonLabel>
        );
    }
    return <></>;
};
